import React from 'react';
import { ShieldCheck } from 'lucide-react';

/**
 * TagoraSeal — Official "Tagora ID Certified" badge.
 * Displays the standard mark + the unique ID.
 *
 * Variants:
 *  - compact: tiny inline badge (for headers, footers)
 *  - default: card-sized badge (for product pages)
 *  - full: large hero variant (for /label page)
 */
const TagoraSeal = ({ tagoraId, variant = 'default', verified = true }) => {
  if (variant === 'compact') {
    return (
      <span
        data-testid="tagora-seal-compact"
        className="inline-flex items-center gap-1 rounded-full border-2 border-charcoal px-2 py-0.5 bg-white text-[10px] font-bold tracking-wider"
        title={tagoraId}
      >
        <ShieldCheck className="w-3 h-3" strokeWidth={2.5} />
        TAGORA ID
      </span>
    );
  }

  return (
    <div
      data-testid="tagora-seal"
      className={`relative inline-flex flex-col items-center justify-center border-2 border-charcoal rounded-2xl bg-white shadow-brutal-sm ${
        variant === 'full' ? 'p-6 min-w-[280px]' : 'p-3 min-w-[200px]'
      }`}
    >
      {/* Stamp ring */}
      <div className="flex items-center gap-2 mb-1">
        <span className={`${verified ? 'bg-secondary' : 'bg-gray-200'} w-7 h-7 rounded-full border-2 border-charcoal flex items-center justify-center`}>
          <ShieldCheck className="w-4 h-4 text-charcoal" strokeWidth={2.5} />
        </span>
        <div className="text-left">
          <p className="text-[9px] font-bold tracking-[0.18em] uppercase text-charcoal/50 leading-none">
            {verified ? 'Certified' : 'Format'}
          </p>
          <p className={`${variant === 'full' ? 'text-lg' : 'text-sm'} font-heading font-bold tracking-tight leading-tight`}>
            TAGORA ID
          </p>
        </div>
      </div>
      {tagoraId && (
        <code
          className={`block font-mono font-bold ${variant === 'full' ? 'text-base' : 'text-xs'} tracking-wide bg-surface-alt rounded-md px-2 py-1 mt-1 border border-charcoal/10`}
        >
          {tagoraId}
        </code>
      )}
      {variant === 'full' && (
        <p className="text-[10px] text-charcoal/50 mt-2 text-center max-w-[260px]">
          Identifiant anonyme conforme au standard ouvert Tagora ID
        </p>
      )}
    </div>
  );
};

export default TagoraSeal;
